<template>
  <mdb-container class="searchBar rounded z-depth-1 bg-white py-2 mb-2 mb-lg-5">
    <mdb-row fluid>
      <mdb-col>
        <mdb-row>
          <mdb-col>
            <h2 class="searchBar__heading">
              Find the optimal test studio for your project
            </h2>
          </mdb-col>
        </mdb-row>

        <mdb-row class="mt-4">
          <mdb-col>
            <h2 class="isi-sub-heading-gray">
              Test Type<span v-show="user && user.role == 2"
                >&nbsp;<i
                  class="info-btn fas fa-info-circle fa-sm"
                  @click="openInfoModal(4)"
                ></i
              ></span>
            </h2>
          </mdb-col>
        </mdb-row>

        <mdb-row>
          <mdb-col>
            <mdb-select
              class="isi-select"
              v-model="testTypesMdb"
              :visibleOptions="parseInt(10)"
              outline
            />
          </mdb-col>
        </mdb-row>

        <mdb-row class="mt-2">
          <mdb-col>
            <h2 class="isi-sub-heading-gray">Locations</h2>
          </mdb-col>
        </mdb-row>

        <mdb-row>
          <mdb-col>
            <mdb-tooltip
              material
              :delayOnMouseOut="300"
              trigger="hover"
              :options="{ placement: 'left' }"
            >
              <span slot="tip">Multiple selections possible</span>
              <mdb-select
                class="isi-select isi-select-locations"
                v-model="countriesMdb"
                label="Where do you want to test?"
                multiple
                :visibleOptions="parseInt(10)"
                outline
                ref="countriesMdb"
                slot="reference"
              />
            </mdb-tooltip>
          </mdb-col>
        </mdb-row>

        <mdb-row>
          <mdb-col>
            <a
              class="btn btn-sm btn-isi m-0 mt-2"
              @click="$emit('mapsButtonClicked')"
              >Locations map</a
            >
          </mdb-col>
          <mdb-col class="pl-0 text-right">
            <mdb-btn
              v-show="internalUser"
              class="btn btn-sm btn-isi m-0 mt-2"
              @click="handleCustomLocationClick"
              >Can't find location?</mdb-btn
            >
            <!-- <span @click="openFurtherLocationsModal" class="link link-isi-sm"
              >Further countries</span
            > -->
          </mdb-col>
        </mdb-row>

        <transition name="fade">
          <div v-if="showWhatElseFilters">
            <mdb-row class="mt-4">
              <mdb-col>
                <h2 class="isi-sub-heading-gray">What else do you need?</h2>
              </mdb-col>
            </mdb-row>

            <mdb-row class="mt-2">
              <mdb-col>
                <p class="my-2 isi-heading-category">
                  Rooms &amp; Facilities
                  <i
                    class="fas fa-info-circle fa-sm"
                    @click="openInfoModal(1)"
                  ></i>
                </p>
                <template v-for="feature in featuresThree">
                  <mdb-input
                    class="isi-input__checkbox"
                    :id="'feature-check-' + feature.id"
                    :key="feature.id"
                    type="checkbox"
                    filled
                    v-model="feature.checked"
                    :label="feature.displayName"
                  />
                </template>
              </mdb-col>
            </mdb-row>

            <mdb-row class="mt-2">
              <mdb-col>
                <p class="my-1 isi-heading-category">
                  IT &amp; Technology
                  <i
                    class="fas fa-info-circle fa-sm"
                    @click="openInfoModal(2)"
                  ></i>
                </p>
                <template v-for="feature in featuresTwo">
                  <mdb-input
                    class="isi-input__checkbox"
                    :id="'feature-check-' + feature.id"
                    :key="'featureInput-' + feature.id"
                    type="checkbox"
                    filled
                    v-model="feature.checked"
                    :label="feature.displayName"
                  />
                </template>
              </mdb-col>
            </mdb-row>

            <mdb-row class="mt-2">
              <mdb-col>
                <p class="my-1 isi-heading-category">
                  Product Storage &amp; Preparation
                  <i
                    class="fas fa-info-circle fa-sm"
                    @click="openInfoModal(3)"
                  ></i>
                </p>
                <template v-for="feature in featuresOne">
                  <mdb-input
                    class="isi-input__checkbox"
                    :id="'feature-check-' + feature.id"
                    :key="feature.id"
                    type="checkbox"
                    filled
                    v-model="feature.checked"
                    :label="feature.displayName"
                  />
                </template>
              </mdb-col>
            </mdb-row>
            <mdb-row class="mt-3 mb-2">
              <mdb-col class="d-flex justify-content-start">
                <a
                  class="btn btn-sm btn-isi-secondary ml-0 mb-0"
                  @click="clearSearch"
                  >Clear Search</a
                >
              </mdb-col>
            </mdb-row>
          </div>
        </transition>
        <mdb-row v-show="showSearchDetailsButton">
          <mdb-col class="d-flex justify-content-end">
            <a
              class="btn btn-sm btn-isi ml-0"
              @click="showWhatElseFilters = !showWhatElseFilters"
              >{{ showWhatElseFilters ? "Less Details" : "More Details" }}</a
            >
          </mdb-col>
        </mdb-row>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import studioIsFiltered from "@/modules/studioIsFiltered.js";

export default {
  methods: {
    setLocationDropdownEntries(testType) {
      // set countriesMdb from countries and searchParams
      let out = [];

      for (let continent of this.continents.sort((a, b) => {
        if (a.displayName > b.displayName) return 1;
        if (a.displayName < b.displayName) return -1;
        return 0;
      })) {
        out.push({
          text: continent.displayName,
          value: null,
          disabled: true,
          optgroup: true,
        });

        for (let country of this.countries
          .filter((el) => el.continentData.id == continent.id)
          .sort((a, b) => {
            if (a.displayName > b.displayName) return 1;
            if (a.displayName < b.displayName) return -1;
            return 0;
          })) {
          let disabled = !country.availableTestTypes.includes(testType);
          let selected =
            this.$store.state.searchParams.countries.includes(country.id) &&
            !disabled;

          out.push({
            text: country.displayName,
            value: country.id,
            disabled,
            selected,
          });
        }
      }
      this.countriesMdb = out;
      this.countriesMdb.sort();
    },
    handleCustomLocationClick() {
      this.$store.commit("setCurrentModal", {
        type: "CustomLocationModal",
        options: {
          testType: this.searchParamsProxy.testType,
        },
      });
    },
    openInfoModal(type) {
      switch (type) {
        case 1:
          this.$store.commit("setCurrentModal", {
            type: "InfoRoomsAndFacilitiesModal",
            options: {
              title: "Rooms & Facilites",
            },
          });
          break;
        case 2:
          this.$store.commit("setCurrentModal", {
            type: "InfoItAndTechnologyModal",
            options: {
              title: "IT & Technology",
            },
          });
          break;
        case 3:
          this.$store.commit("setCurrentModal", {
            type: "InfoProductStrorageAndPreparationModal",
            options: {
              title: "Product Storage & Preparation",
            },
          });
          break;
        case 4:
          this.$store.commit("setCurrentModal", {
            type: "InfoTestType",
          });
          break;
        default:
          break;
      }
    },
    // openFurtherLocationsModal() {
    //   this.$store.commit("setCurrentModal", {
    //     type: "FurtherLocationsModal",
    //     options: {
    //       testTypesMdb: JSON.parse(JSON.stringify(this.testTypesMdb)),
    //     },
    //   });
    // },
    applySearch() {
      if (
        JSON.stringify(this.$store.state.searchParams) ==
        JSON.stringify(this.searchParamsProxy)
      ) {
        return;
      }
      if (
        this.user &&
        this.user.requestList.testType &&
        this.user.requestList.testType != this.searchParamsProxy.testType &&
        this.user.requestList.testStudioIds.length > 0
      ) {
        this.$store.commit("setCurrentModal", {
          type: "testTypemismatchModal",
          options: {
            clearRequestList: true,
            adjustSearch: true,
            // nur true, wenn Search button mit searchProxy
            back: false,
            searchParamsProxy: this.searchParamsProxy,
          },
        });
      } else {
        this.$store.commit("setSearchParams", this.searchParamsProxy);
      }
    },
    clearSearch() {
      this.$store.commit("clearSearch", this.searchParamsProxy.testType);
    },
    selectTestType(id) {
      this.testTypesMdb.forEach((option) => {
        option.selected = false;
      });
      let ind = this.testTypesMdb.findIndex((x) => x.value == id);
      this.$set(this.testTypesMdb[ind], "selected", true);
      this.testTypesMdb.sort();
    },
    selectCountries(ids, testType) {
      for (let countryMdb of this.countriesMdb) {
        if (
          !countryMdb.optgroup &&
          !this.countries
            .find((country) => country.id == countryMdb.value)
            .availableTestTypes.includes(testType)
        ) {
          countryMdb.disabled = true;
          countryMdb.selected = false;
        } else {
          if (ids.includes(countryMdb.value)) {
            countryMdb.selected = true;
          } else {
            countryMdb.selected = false;
          }
          countryMdb.disabled = false;
        }
      }
      this.countriesMdb.sort();
    },
    selectFeatures(ids) {
      for (let el of this.featuresMdb) {
        if (ids.includes(el.id)) {
          el.checked = true;
        } else {
          el.checked = false;
        }
      }
    },
    deselectFeature(id) {
      this.featuresMdb.find((x) => x.id == id).checked = false;
    },
    deselectCountry(id) {
      this.countriesMdb.find((x) => x.value == id).selected = false;
      this.countriesMdb.sort();
    },
  },
  data() {
    return {
      testTypesMdb: [],
      countriesMdb: [],
      featuresMdb: [],
      showWhatElseFilters: true,
      showSearchDetailsButton: false,
    };
  },
  created() {
    if (window.innerWidth < 992) {
      this.showWhatElseFilters = false;
      this.showSearchDetailsButton = true;
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth < 992) {
        if (!this.showSearchDetailsButton) {
          this.showSearchDetailsButton = true;
        }
      } else {
        if (!this.showWhatElseFilters) {
          this.showWhatElseFilters = true;
        }
        if (this.showSearchDetailsButton) {
          this.showSearchDetailsButton = false;
        }
      }
    });

    let testType = this.$store.state.searchParams.testType;

    // set testTypesMdb from testTypes and searchParams
    let out = [];
    for (let el of this.testTypes) {
      let selected = testType == el.id ? true : false;
      out.push({
        text: el.displayName,
        value: el.id,
        selected: selected,
      });
    }
    this.testTypesMdb = out;

    this.setLocationDropdownEntries(testType);

    // set featuresMdb from features and searchParams
    out = [];
    for (let key in this.features) {
      let el = this.features[key];
      let checked = this.$store.state.searchParams.features.includes(el.id);
      out.push({
        id: el.id,
        displayName: el.displayName,
        checked: checked,
        category: el.category,
        position: el.position,
      });
    }
    this.featuresMdb = out.sort((a, b) => {
      if (a.position > b.position) return 1;
      if (a.position < b.position) return -1;
      return 0;
    });

    this.$watch("searchParamsProxy", () => {
      this.applySearch();
    });
  },
  computed: {
    internalUser() {
      return (this.user ?? false) && (this.user.role == 2 || this.user.role == 3);
    },
    searchParamsProxy() {
      return {
        testType: this.selectedTestType,
        countries: this.selectedCountries,
        features: this.selectedFeatures,
      };
    },
    selectedTestType() {
      return this.testTypesMdb.find((x) => x.selected == true).value;
    },
    selectedCountries() {
      return this.countriesMdb
        .filter((x) => x.selected == true)
        .map((x) => x.value);
    },
    selectedFeatures() {
      return this.featuresMdb.filter((x) => x.checked).map((x) => x.id);
    },
    testTypes() {
      return this.$store.state.testTypes;
    },
    features() {
      return this.$store.state.features;
    },
    countries() {
      return this.$store.state.countries;
    },
    continents() {
      return this.$store.state.continents;
    },
    user() {
      return this.$store.state.user;
    },
    searchProxyCount() {
      return this.$store.state.testStudios.items.filter(
        (x) => !studioIsFiltered(this.searchParamsProxy, x)
      ).length;
    },
    searchBtnText() {
      let pluralS = this.searchProxyCount > 1 ? "s" : "";
      return this.searchProxyCount + ` location${pluralS} left`;
    },
    featuresOne() {
      return this.featuresMdb.filter(function (feature) {
        if (feature.category == 1) {
          return feature;
        }
      });
    },
    featuresTwo() {
      return this.featuresMdb.filter(function (feature) {
        if (feature.category == 2) {
          return feature;
        }
      });
    },
    featuresThree() {
      return this.featuresMdb.filter(function (feature) {
        if (feature.category == 3) {
          return feature;
        }
      });
    },
  },
  watch: {
    "$store.state.searchParams"(newVal) {
      this.selectTestType(newVal.testType);
      this.selectCountries(newVal.countries, newVal.testType);
      this.selectFeatures(newVal.features);
    },
    "$store.state.countries"() {
      this.setLocationDropdownEntries(this.$store.state.searchParams.testType);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/components/search/_searchBar.scss";
</style>